import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ScheduleOptionsProp } from '../models/Exam';
import { QuestionserviceService } from '../services/questionservice.service';

export interface IpsativeAnswer {
  mostOptionId: number | null;
  leastOptionId: number | null;
}

@Component({
  selector: 'app-ipsative-block',
  templateUrl: './ipsative-block.component.html',
  styleUrls: ['./ipsative-block.component.css']
})
export class IpsativeBlockComponent implements OnChanges {
  @Input() statements: ScheduleOptionsProp[] = [];
  @Input() schedulequestionid: number;

  @Output() answerChanged: EventEmitter<IpsativeAnswer> = new EventEmitter();

  mostOptionId: number | null = null;
  leastOptionId: number | null = null;

  constructor(private questionservice: QuestionserviceService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['schedulequestionid'] || changes['statements']) {
      this.loadExistingAnswer();
    }
  }

  private loadExistingAnswer() {
    this.mostOptionId = null;
    this.leastOptionId = null;

    if (!this.schedulequestionid) {
      return;
    }

    const data = this.questionservice.getAnsweredquestion(this.schedulequestionid);

    if (data?.optionRoles) {
      const roles: { [optionId: string]: string } = data.optionRoles;
      for (const optionId of Object.keys(roles)) {
        if (roles[optionId] === 'Most') {
          this.mostOptionId = Number(optionId);
        } else if (roles[optionId] === 'Least') {
          this.leastOptionId = Number(optionId);
        }
      }
      return;
    }

    for (const statement of this.statements || []) {
      if (statement.role === 'Most') {
        this.mostOptionId = statement.optionid;
      } else if (statement.role === 'Least') {
        this.leastOptionId = statement.optionid;
      }
    }
  }

  selectMost(optionId: number) {
    if (this.leastOptionId === optionId) {
      this.leastOptionId = null;
    }
    this.mostOptionId = optionId;
    this.emitAnswer();
  }

  selectLeast(optionId: number) {
    if (this.mostOptionId === optionId) {
      this.mostOptionId = null;
    }
    this.leastOptionId = optionId;
    this.emitAnswer();
  }

  private emitAnswer() {
    this.answerChanged.emit({ mostOptionId: this.mostOptionId, leastOptionId: this.leastOptionId });
  }
}
